// import React from 'react';
// import { ModalBody as CoreModalBody } from '@vds-core/modals';
// import { TypographyConfig, BodyConfig } from '@vds/typography';
// const typescale = TypographyConfig.getTypescale();
// const bodyPadding = `24px 0 1px 0`;
// const ModalBody = props => {
//   function _calcTypography(bodyConfig, viewport, typescale) {
//     return BodyConfig.getStyles(typescale, 'desktop', 'large');
//   }
//   return (
//     <CoreModalBody
//       {...props}
//       typescale={typescale}
//       bodyConfig={BodyConfig}
//       calcTypography={_calcTypography}
//       padding={bodyPadding}
//     />
//   );
// };
import { ModalBody } from '@vds-core/modals';
export default ModalBody;